const TONES = {
  amber: "bg-amber-50/70 border-amber-200 text-amber-900 [&_svg]:text-amber-600",
  orange: "bg-orange-50/70 border-orange-200 text-orange-900 [&_svg]:text-orange-600",
  blue: "bg-sky-50/70 border-sky-200 text-sky-900 [&_svg]:text-sky-600",
  rose: "bg-rose-50/70 border-rose-200 text-rose-900 [&_svg]:text-rose-600",
  emerald: "bg-emerald-50/70 border-emerald-200 text-emerald-900 [&_svg]:text-emerald-600",
  slate: "bg-white border-slate-200 text-slate-900 [&_svg]:text-slate-500",
};

export const KpiCard = ({ label, value, sub, icon: Icon, tone = "slate", testId, delay = 0 }) => (
  <div data-testid={testId} style={{ animationDelay: `${delay}ms` }}
    className={`fade-up rounded-xl border p-5 shadow-sm hover:shadow-md transition-shadow duration-200 ${TONES[tone]}`}>
    <div className="flex items-center justify-between">
      <span className="text-xs font-semibold uppercase tracking-wider opacity-70">{label}</span>
      {Icon && <Icon className="h-4 w-4" />}
    </div>
    <div className="num mt-3 text-2xl font-bold tracking-tight" data-testid={`${testId}-value`}>{value}</div>
    {sub && <div className="mt-1 text-xs opacity-70">{sub}</div>}
  </div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
    <div>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, right, children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-xl border border-slate-200 bg-white shadow-sm ${className}`}>
    {(title || right) && (
      <div className="flex items-center justify-between gap-3 border-b border-slate-100 px-5 py-4">
        <h3 className="text-base font-semibold text-slate-800">{title}</h3>
        {right}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);
